import { get, patch } from 'src/utils/networkUtils';

// Well-known global feature flag keys (mirror of the backend FEATURE_FLAG_KEYS).
export const FEATURE_FLAG_KEYS = {
  SIMULATOR_MODE: 'simulator_mode',
  DISABLE_FINAL_POINTS_DELAY: 'disable_final_points_delay',
};

// Lists global feature flags. Returns an array (empty on failure shape mismatch).
export async function listFeatureFlags() {
  const body = await get('/admin/feature-flags');
  return Array.isArray(body?.data) ? body.data : [];
}

// Enables/disables a global feature flag. Returns the updated flag row.
export async function setFeatureFlag(key, isEnabled, description) {
  const body = await patch('/admin/feature-flags', {
    key,
    is_enabled: isEnabled,
    ...(description !== undefined ? { description } : {}),
  });
  return body?.data ?? null;
}
